import logoFull from "./images/logo-biond-full.svg";
import logoSymbol from "./images/logo-biond-symbol.svg";
import logoTwitter from "./images/logo-twitter.svg";
import logoFacebook from "./images/logo-fb-simple.svg";
import biondDashboard from "./images/biond-dashboard.png";
import blogVisualDefault from "./images/blog-visual-default.jpg";
import blogVisualPrivacy from "./images/blog-visual-privacy.jpg";
import illustrationHomeHero from "./illustrations/illustration-home-hero.svg";
import illustrationHomePrivacy from "./illustrations/illustration-home-privacy.svg";
import illustrationFolder from "./illustrations/illustration-folder.svg";
import illustrationPhoneMark from "./illustrations/illustration-phone-mark.svg";
import illustrationPhoneWoman from "./illustrations/illustration-phone-woman.svg";
import illustrationContactPhone from "./illustrations/illustration-contact-phone.svg";
import illustrationAboutHeader from "./illustrations/illustration-about-header.svg";
import illustrationBusinessHeader from "./illustrations/illustration-business-header.svg";
import illustrationBiondStore from "./illustrations/illustration-biond-store-group.svg";
import illustrationMessaging from "./illustrations/illustration-messaging.svg";
import illustrationMessagingAlt from "./illustrations/illustration-messaging-alt.svg";
import illustrationWave from "./illustrations/illustration-wave.svg";
import illustrationCoins from "./illustrations/illustration-coins.svg";

export default {
    logoFull,
    logoSymbol,
    logoTwitter,
    logoFacebook,
    illustrationHomeHero,
    illustrationHomePrivacy,
    illustrationFolder,
    illustrationPhoneMark,
    illustrationPhoneWoman,
    illustrationContactPhone,
    illustrationAboutHeader,
    illustrationBusinessHeader,
    biondDashboard,
    illustrationBiondStore,
    illustrationMessaging,
    illustrationMessagingAlt,
    illustrationWave,
    illustrationCoins,
    blogVisualDefault,
    blogVisualPrivacy
};



// WEBPACK FOOTER //
// ./src/assets/images.js